import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Paper, Typography } from '@mui/material';

import StepTabs from '../../../../StepTabs';
import TabContainer from './Contents/TabContainer';
import useWidth from '../../../../../Hooks/useWidth';
import CommentsSection from '../../../../Comments/Show';
import { getDefaultStepIndex, getPostStepsWithStatus } from '../../../../../Utils/Steps';
import { Steps } from '../../../../../Utils/Types';

function Tabs({ post }: any) {
  const intl = useIntl();
  let postSteps = getPostStepsWithStatus(post, intl);

  postSteps = postSteps.filter((step: any) => {
    if (
      step.step_type === Steps[post.type].IMPLEMENTATION &&
      !step.open_to_citizen_and_contributor
    ) {
      return null;
    }
    return step;
  });

  const isMobile = useWidth('down', 'sm');
  const [activeTabIndex, setActiveTabIndex] = useState(getDefaultStepIndex(post));

  return (
    <>
      <Box sx={{ mb: { xs: 3, sm: 0 } }}>
        <StepTabs
          tabs={postSteps}
          value={activeTabIndex}
          onChange={(_: any, newIndex: any) => {
            setActiveTabIndex(newIndex);
          }}
        />
      </Box>

      <div id="children-ideas-list">
        <Paper
          elevation={isMobile ? 0 : 1}
          sx={{
            pt: { xs: 3, sm: 2 },
            px: { xs: 1, sm: 0 },
            mx: { xs: -2, sm: 0 },
          }}
        >
          {postSteps.map((step: any, i: any) => (
            // For Accessibility reasons, we have to render a #phase-step-panel-${i} for each tab
            <div key={step.id} id={`phase-step-panel-${i}`}>
              {activeTabIndex === i && (
                <TabContainer post={post} stepTab={postSteps[activeTabIndex]} />
              )}
            </div>
          ))}
        </Paper>

        {post?.display_options?.comments_enabled && (
          <>
            <Box sx={{ mt: 5, mb: 3 }}>
              <Typography variant="h5" component="h2">
                <FormattedMessage id="COMMENTS.TITLE" />
              </Typography>
            </Box>

            <CommentsSection post={post} />
          </>
        )}
      </div>
    </>
  );
}

export default Tabs;
